import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useL10n } from '@uplift/hooks';

const useStyles = makeStyles({ name: 'SupportPaymentLabel' })((theme) => ({
  cashBlock: {
    display: 'flex',
    fontSize: '14px',
    fontWeight: 600,
    color: '#2B5040',
    lineHeight: 1,
    marginBottom: theme.spacing(2)
  },
  acceptsIcon: {
    position: 'relative',
    marginLeft: '18px',
    '&::before': {
      content: '"✓"',
      fontSize: '20px',
      position: 'absolute',
      left: '-20px',
      color: theme.palette.success.main,
      top: '-3px',
    },
  },
  companyName: {
    maxWidth: '200px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  underlinedText: {
    borderBottom: `2px solid ${theme.palette.success.main}`,
    textTransform: 'uppercase',
    marginRight: '5px',
  },
}));


export type SupportPaymentLabelProps = {
  isAcceptInsurance?: boolean;
  isPsychiatrist?: boolean;
  text?: string;
  className?: string;
  isBookingSponsored?: boolean;
};

export const SupportPaymentLabel: React.VFC<SupportPaymentLabelProps> = ({
  isAcceptInsurance,
  isPsychiatrist = false,
  text,
  className,
  isBookingSponsored = false,
}) => {
  const { classes, cx } = useStyles();
  const l10n = useL10n();

  const underlinedText = isAcceptInsurance
    ? l10n.matching.payment.accepts
    : l10n.matching.payment.cashPrice;

  const labelText = !isAcceptInsurance
    ? l10n.matching.payment.sessionPrice(isPsychiatrist ? '$175-$250' : '$125-$145')
    : text;

  return isBookingSponsored ? null : (
    <Box display="inline" className={cx([ classes.cashBlock, className ])}>
      <div
        className={cx(classes.underlinedText, {
          [classes.acceptsIcon]: isAcceptInsurance,
        })}
      >
        {underlinedText}
      </div>
      <div className={classes.companyName}>{labelText}</div>
    </Box>
  );
};
